// Single source of truth for the admin allowlist on the frontend.
//
// Mirrors the same set used by:
//   • analytics.worker_runs.admin_read_worker_runs RLS policy (DB-side)
//
// Adding/removing an admin requires updating BOTH this file AND the RLS policy
// migration. See CLAUDE.md → "Admin pages + emails".

// Superadmin = the tier above admin (superadmin-only tools: /admin/marketing).
// Every superadmin is an admin BY CONSTRUCTION — ADMIN_EMAILS spreads this set
// in — so no admin-gated surface can ever lock a superadmin out.
//
// NO DB mirror yet: no DB object is superadmin-gated today, so the RLS policy
// above only knows the admin list. Whoever gates DB data on superadmin must add
// a policy for it — this file protects nothing the database serves directly.
export const SUPER_ADMIN_EMAILS: ReadonlySet<string> = new Set([
  "chirkovtaras@gmail.com",
  "babasvetaa@gmail.com",
]);

export const ADMIN_EMAILS: ReadonlySet<string> = new Set([
  ...SUPER_ADMIN_EMAILS,
  "zucc@octogames.studio",
  "spammailbambyrek@gmail.com",
  "den@octogames.studio",
]);

/** The sets hold lowercase emails; compare case- and whitespace-insensitively. */
function normalizeEmail(email: string | null | undefined): string {
  return email?.trim().toLowerCase() ?? "";
}

export function isAdminEmail(email: string | null | undefined): boolean {
  return ADMIN_EMAILS.has(normalizeEmail(email));
}

export function isSuperAdminEmail(email: string | null | undefined): boolean {
  return SUPER_ADMIN_EMAILS.has(normalizeEmail(email));
}
